import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  padding: 16px;
  overflow: hidden;

  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  /* Abaixo de 980px o toast nao some mais: encolhe para a largura util da
     tela, em vez de ser escondido (o feedback precisa aparecer em qualquer
     largura). */
  @media (max-width: 980px) {
    left: 0;
    align-items: stretch;
    padding: 12px;
  }
`;
